import React from "react";
import data from "../../../assets/apiRoutes.json";
import axios from "axios";
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import Popup from "devextreme-react/popup";
import { CUSTOMER_LOGIN_TYPE } from "../../../common/permissions";
const DeleteTransactionDialog = (props) => {
  var accessToken = props.oidc.user.access_token;
  const deleteTransaction = (rowid) => {
    var deleteReceiptObject = {
      rowid: rowid,
      dbName:
        props.ReceiptReducer.wmTransactionDatabase !== ""
          ? props.ReceiptReducer.wmTransactionDatabase
          : "",
    };
    axios
      .post(
        `${window._env_.REACT_APP_APIS}/${data.Receipt.DeleteTransactions}`,
        deleteReceiptObject,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
          },
        }
      )
      .then((resp) => {
        props.loadTransactions();
      });
    props.handleClose();
  };
  return (
    <div>
      <Popup
        visible={props.openDialog}
        onHiding={props.handleClose}
        dragEnabled={false}
        closeOnOutsideClick={true}
        title="Deleting Transaction"
        showCloseButton={true}
        width={530}
        height={250}
      >
        {
          props.ReceiptReducer.receipt.length > 0 &&
            props.ReceiptReducer.receipt[0]?.actualreceivedshippeddatetime != undefined &&
            props.ReceiptReducer.receipt[0]?.actualreceivedshippeddatetime != null &&
            (!props.oidc.user.profile.hasOwnProperty("LOGINTYPEID") || props.oidc.user.profile.LOGINTYPEID == CUSTOMER_LOGIN_TYPE)
            ? (
              <>
                <h6 className="text-danger">
                  This order has been scheduled and should not be deleted.
                </h6>
                <Button
                  onClick={props.handleClose}
                  className="gridTopButton"
                  type="default"
                  text="Ok" />
              </>
            ) : (<>
              <h5>
                Are you sure you want to delete this open Transaction #:
                <span style={{ color: window._env_.Color2 }}> {props.transactionNumber}
                </span>
                ?
              </h5>
              <Button
                onClick={() => deleteTransaction(`${props.rowid}`)}
                className="gridTopButton"
                type="default"
                text="Confirm" />
              <Button
                onClick={props.handleClose}
                className="gridTopButton"
                text="Cancel" />
            </>
            )}
      </Popup>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}
export default connect(mapStateToProps)(DeleteTransactionDialog);
